import {
  TTaskActivitiesResponse,
  TTaskActivity,
} from '@commenda/types/src/tasks/types';
import { SWRFetcher } from '@commenda/utils';
import { TaskActivityActionType, TaskStatus } from '@prisma/client';
import useSWR from 'swr';

export function useTaskActivitiesForServiceRequest(
  serviceRequestId: string | null | undefined
) {
  const { data, error, mutate } = useSWR<TTaskActivitiesResponse>(
    serviceRequestId
      ? `tasks/activities?serviceRequestId=${serviceRequestId}`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, mutate, isLoading: !data && !error };
}

type TAttentionFixerTask = {
  id: number;
  status: TaskStatus;
  completedAt: Date | string | null;
};

export function pairHasOpenIssue(
  activities: TTaskActivity[] | undefined,
  fixerTask: TAttentionFixerTask | null | undefined,
  reviewerTask?: { id: number } | null
): boolean {
  if (!activities?.length || !fixerTask) return false;

  const newestAttention = activities.find(
    (a) =>
      (a.actionType === TaskActivityActionType.ISSUE_REPORTED &&
        (a.taskId === fixerTask.id || a.taskId === reviewerTask?.id)) ||
      (a.actionType === TaskActivityActionType.ACTION_REQUIRED_RAISED &&
        a.taskId === fixerTask.id)
  );
  if (!newestAttention) return false;

  const fixedAfter =
    fixerTask.status === TaskStatus.COMPLETED &&
    fixerTask.completedAt !== null &&
    new Date(fixerTask.completedAt) >= new Date(newestAttention.createdAt);

  return !fixedAfter;
}
